import { Card } from '@/components/ui/card';
import { User, Car, Wrench, Calendar } from '@phosphor-icons/react';
import { formatDate, formatTime } from '@/services/serviceApi';
import './AppointmentSummary.css';

export function AppointmentSummary({ appointmentData }) {
  const {
    customerName,
    phone,
    licensePlate,
    carYear,
    carMake,
    carModel,
    serviceName,
    standardPrice,
    requiredHours,
    appointmentDate,
    appointmentTime
  } = appointmentData;

  const summaryItems = [
    {
      icon: User,
      title: 'Customer',
      lines: [customerName, phone]
    },
    {
      icon: Car,
      title: 'Vehicle',
      lines: [
        `${carYear} ${carMake} ${carModel}`,
        `License: ${licensePlate}`
      ]
    },
    {
      icon: Wrench,
      title: 'Service',
      lines: [
        serviceName,
        `Duration: ~${requiredHours}h`,
        standardPrice > 0 ? `Price: from €${standardPrice}` : 'Contact for exact price'
      ]
    },
    {
      icon: Calendar,
      title: 'Appointment',
      lines: [
        formatDate(appointmentDate),
        formatTime(appointmentTime)
      ]
    }
  ];

  return (
    <div className="appointment-summary">
      {summaryItems.map((item, index) => {
        const Icon = item.icon;
        return (
          <Card key={index} className="appointment-summary__card">
            <div className="appointment-summary__body">
              <div className="appointment-summary__icon">
                <Icon size={20} />
              </div>
              <div className="appointment-summary__content">
                <h4 className="appointment-summary__title">{item.title}</h4>
                {item.lines.map((line, lineIndex) => (
                  <p key={lineIndex} className="appointment-summary__line">
                    {line}
                  </p>
                ))}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
